import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import { ISignUpRequest } from "app/api/types/Auth";
import { IAuthResponse } from "app/api/types/User";

import api from "app/api/requests/Auth";

export const SIGN_UP_REQUEST = "SIGN_UP_REQUEST";
export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS";
export const SIGN_UP_FAIL = "SIGN_UP_FAIL";

export const signUp = (data: ISignUpRequest) => (dispatch: any): any => {
  dispatch({ type: SIGN_UP_REQUEST });
  return api
    .signUp(data)
    .then((response: AxiosResponse) => {
      const auth: IAuthResponse = get(response, "data", {});

      sessionStorage.setItem("token", auth.token);

      dispatch({ type: SIGN_UP_SUCCESS, payload: auth });

      return auth;
    })
    .catch(err => {
      dispatch({
        type: SIGN_UP_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
